import { createNanoEvents } from 'nanoevents';
export var StorageEvent;
(function (StorageEvent) {
    /**
     * Emit when the database is ready to use
     */
    StorageEvent["Ready"] = "Ready";
    /**
     * Emit when the database is failed to open or unexpected closed
     */
    StorageEvent["Fetal"] = "Fetal";
    /**
     * Emit when the database is requested to be closed by user
     */
    StorageEvent["Closed"] = "Closed";
    /**
     * Emit when the database is requested to be closed by user
     */
    StorageEvent["Destroyed"] = "Destroyed";
    /**
     * Emit when the database encounters internal errors
     */
    StorageEvent["Error"] = "Error";
    /**
     * Emit when a new model is registered
     */
    StorageEvent["RegisterModel"] = "RegisterModel";
    /**
     * Emit when a new plugin is registered
     */
    StorageEvent["RegisterPlugin"] = "RegisterPlugin";
    /**
     * @deprecated
     */
    StorageEvent["BootstrapStart"] = "BootstrapStart";
    /**
     * @deprecated
     */
    StorageEvent["BootstrapEnd"] = "BootstrapEnd";
    /**
     * @deprecated
     */
    StorageEvent["SchemaMigrationStart"] = "SchemaMigrationStart";
    /**
     * @deprecated
     */
    StorageEvent["SchemaMigrationEnd"] = "SchemaMigrationEnd";
    /**
     * Emit when the database version is changed
     */
    StorageEvent["VersionChange"] = "VersionChange";
})(StorageEvent || (StorageEvent = {}));
export var InternalEvent;
(function (InternalEvent) {
    InternalEvent["CollectionCreated"] = "CollectionCreated";
    InternalEvent["ModelLazyMigrationEnd"] = "ModelLazyMigrationEnd";
    InternalEvent["PrepareAutoUpgradeEnd"] = "PrepareAutoUpgradeEnd";
    InternalEvent["UpdateMigrationChangeInfo"] = "UpdateMigrationChangeInfoEnd";
    InternalEvent["StartTransaction"] = "StartTransaction";
})(InternalEvent || (InternalEvent = {}));
export function createEvents() {
    return createNanoEvents();
}
//# sourceMappingURL=events.js.map